import { useNavigate } from "react-router-dom"
import { ReactNode } from "react"

export interface LinkProps {
    children: ReactNode
    href?: string
    to?: string
    download?: string
    onClick?: () => void
    target?: "_blank" | "_self" | "_parent" | "_top"; 
    rel?: string; 
}

export const LinkStyle: string =
    "text-primary-600 cursor-pointer hover:underline hover:text-primary-700"

export const BlackLinkStyle: string =
    "text-black cursor-pointer hover:underline "

function Link(props: LinkProps) {
    const navigate = useNavigate()

    function onClick() {
        if (props.href !== undefined) window.location.href = props.href
        if (props.to !== undefined) navigate(props.to)
        if (props.onClick !== undefined) props.onClick()
    }
    if (props.download !== undefined) {
        return (
            <a href={props.download} download className={LinkStyle}>
                {props.children}
            </a>
        );
    }

    if (props.href && props.target === "_blank") {
        return (
            <a
                href={props.href}
                target="_blank"
                rel="noopener noreferrer"
                className={LinkStyle}
            >
                {props.children}
            </a>
        );
    }

    return (
        <div onClick={onClick} className={LinkStyle}>
            {props.children}
        </div>
    );
}

export default Link
